import { h } from '@stencil/core';

export const renderFormError = (errors, messages) => {
  let errorMessages = null;
  if (typeof messages === 'string' && errors) {
    // if we set the message as a string from Storybook then just display it
    errorMessages = <div class="jui-control__error">{messages}</div>;
    return errorMessages;
  }
  if (errors) {
    const errTypes = Object.keys(errors);
    errorMessages = [];

    errTypes.forEach(key => {
      errorMessages.push(messages[key]);
    });

    // todo dont like this (angular specific error object handling)
    if (errors['minlength'] && typeof errors['minlength'] === 'object') {
      if (!messages['minlength']) {
        console.warn('CORE COMPONENTS: Missing control minlength message for a control with minlength validation');
      }

      errorMessages = errorMessages.filter(x => x !== messages['minlength']);
      errorMessages.push(
        `${messages['minlength']} ${errors['minlength'].requiredLength} (${errors['minlength'].actualLength})`
      );
    }

    return (errorMessages = errorMessages.map((x: any) => {
      return [<div class="jui-control__error">{x}</div>, null];
    }));
  } else {
    errorMessages = null;
    return errorMessages;
  }
};

/**
 * Returns the right edge of the nearest constraining container, capped at the viewport.
 */
const getRightBoundary = (element: HTMLElement): number => {
  let boundary = window.innerWidth;
  let node = element.parentElement;
  while (node && node !== document.body) {
    const right = node.getBoundingClientRect().right;
    if (right > 0 && right < boundary) {
      boundary = right;
    }
    node = node.parentElement;
  }
  return boundary;
};

export const renderTooltipOnLeft = (element: HTMLElement, selector?: string): boolean => {
  const elementSelector = selector ? selector : 'jui-control__input';
  const targetEl = element.shadowRoot.querySelector(`.${elementSelector}`) as HTMLElement;
  if (!targetEl) {
    return false;
  }
  const elementBounds = targetEl.getBoundingClientRect();
  if (elementBounds.width === 0) {
    return false;
  }
  const boundaryRight = getRightBoundary(element);
  return boundaryRight - elementBounds.right < 100;
};

export const renderTooltipOnBottom = (element: HTMLElement, selector?: string): boolean => {
  const elementSelector = selector ? selector : 'jui-control__input';
  const targetEl = element.shadowRoot.querySelector(`.${elementSelector}`) as HTMLElement;
  const elementBounds = targetEl.getBoundingClientRect();
  if (elementBounds.width === 0) {
    return false;
  }
  return elementBounds.top < 100;
};
